import { initialState } from '@results/store/results.state';
import * as actions from './results.actions';
import { createReducer, on } from '@ngrx/store';

export const resultsReducer = createReducer(
  initialState,
  on(actions.hotelRequestGet, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.hotelsRequestSuccess, (state, { payload }) => {
    return {
      ...state,
      ...payload,
      error: null,
      loading: false,
    };
  }),
  on(actions.hotelRequestError, (_state, { payload }) => {
    return {
      ...initialState,
      error: payload.error,
    };
  }),
  on(actions.allLocationRequestGet, (state) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.allLocationRequestSuccess, (state, { payload }) => {
    return {
      ...state,
      loading: false,
      locationData: { ...payload },
    };
  }),
  on(actions.toggleMap, (state, { payload }) => {
    return {
      ...state,
      ...payload,
      viewMap: !state.viewMap,
    };
  }),
  on(actions.recommendedHotelRequestSuccess, (state, { payload }) => {
    return {
      ...state,
      recommendedHotels: {
        ...payload,
      },
    };
  }),
);
